import React from 'react';

import Group, {Item} from '@pb/kit-component-group';
import {Icon, Icons, Sizes} from '@pb/kit-component-icon';

type Props = {
    hasRisksOrRecommendations: boolean,
};

export const EventReviewPushNotification = ({hasRisksOrRecommendations}: Props) => {
    return (
        <>
            {hasRisksOrRecommendations ? (
                <Group direction="v">
                    <Item>AI Assist has identified recommendations for some fields.</Item>
                    <Group direction="v">
                        <Group direction="v" gap="none">
                            <Group gap="xs" alignItems="center">
                                <Item>Please review the fields highlighted with the recommendation icon</Item>
                                <Icon type={Icons.CHAT} size={Sizes.Size_14}/>
                            </Group>
                            <Item>and hover over the icon to view details.</Item>
                        </Group>
                        <Group direction="v" gap="none">
                            <Item><strong>Note:</strong> AI Assist provides recommendations only.</Item>
                            <Item>The Usage Data team does final review and approval</Item>
                        </Group>
                    </Group>
                </Group>
            ) : (
                <Group direction="v" gap="none">
                    <Item>All fields are filled in accordance with best practices.</Item>
                    <Item>Thank you for using AI Assist!</Item>
                </Group>
            )}
        </>
    );
};
